import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=0b9868f8"
import script from "./Announce.vue?vue&type=script&lang=js"
export * from "./Announce.vue?vue&type=script&lang=js"
import style0 from "./Announce.vue?vue&type=style&index=0&id=0b9868f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports